var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqMandatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.568,
    height: 16.364,
    viewBox: "0 0 15.568 16.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e11e5a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16364.216 -8129.694)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.636-12.727l.227-6.25L3.58-15.625,2.216-18.011l5.568-2.9-5.568-2.9L3.58-26.193l5.284,3.352-.227-6.25h2.727l-.227,6.25,5.284-3.352,1.364,2.386-5.568,2.9,5.568,2.9L16.42-15.625l-5.284-3.352.227,6.25Z",
    transform: "translate(16362 8158.785)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqMandatory);
export default __webpack_public_path__ + "static/media/reqMandatory.e73db095a87208b75b96b93df30bb14d.svg";
export { ForwardRef as ReactComponent };